module.exports = __webpack_public_path__ + "img/saturn.f7d6ba9b.png";